import { GetTrainingsSettingsDocument } from 'generated/resources/graphql'
import type { TrainingsSetting } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTrainingsSettings = (companyId: number) => {
  const { loading, data, error } = useQuery(GetTrainingsSettingsDocument, {
    variables: {
      companyId: companyId,
    },
  })

  return {
    error,
    loading,
    settings: data ? data.trainings.settingsConnection.nodes : undefined,
  }
}

export type Setting = TrainingsSetting
